export default "__VITE_ASSET__4db6b901__"